/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdminAuthData,
  logout,
  selectUserData,
  updateAdminAuthData,
} from "redux/AuthSlice/index.slice";
import adminRouteMap from "routeControl/adminRouteMap";
import { AdminAuthServices } from "services/Admin/Auth/index.service";
import { InstructorAuthServices } from "services/Instructor";
import {
  ImageElement,
  logger,
  modalNotification,
  removeLocalStorageToken,
  textFormatter,
} from "utils";
import { nameFormatter } from "../Formatter";
import { SweetAlert } from "../UiElement";

/**
 * AdminHeader component represents the header section of the admin page.
 * It includes user-related information, notifications, and logout functionality.
 * @component
 * @param {Object} props - Props for the component.
 * @param {Function} props.menuToggle - Function to toggle the menu.
 * @returns {JSX.Element} Header component for the admin page.
 */

function AdminHeader({ menuToggle }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);
  const adminData = useSelector(getAdminAuthData);
  const [loading, setLoading] = useState(false);
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);

  const userRole = userData?.user?.role;
  const dispatch = useDispatch();

  /**
   * Show the logout confirmation alert.
   */
  const showSweetAlert = () => {
    setIsAlertVisible(true);
  };

  /**
   * Handle the confirmation of the logout alert.
   */
  const onConfirmAlert = async () => {
    setLoading(true);
    try {
      const url = window.location.href;
      const res = await (url.includes("instructor")
        ? InstructorAuthServices.logoutService()
        : AdminAuthServices.logoutService());
      if (res?.success) {
        modalNotification({
          type: "success",
          message: res?.message,
        });
      }
      removeLocalStorageToken();
      dispatch(logout(navigate, userRole === "admin" ? "admin" : "instructor"));
    } catch (error) {
      logger(error);
    }
    setLoading(false);
  };
  const getAdminData = async () => {
    try {
      const url = window.location.href;
      const response = url.includes("instructor")
        ? await InstructorAuthServices.getInstructorDataService()
        : await AdminAuthServices.getAdminDataService();
      const adminDetails = {
        id: response?.data?.id,
        name: response?.data?.name,
        email: response?.data?.email,
      };
      dispatch(updateAdminAuthData(adminDetails));
    } catch (error) {
      logger(error);
    }
  };

  // const getNotificationData = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await CommonService.getNotificationData();
  //     const { data, success } = res;
  //     if (success) {
  //       setNotificationList(data?.notification?.rows);
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     logger(error);
  //   }
  //   setLoading(false);
  // };
  // const getUnreadNotificationCount = async () => {
  //   try {
  //     const res = await CommonService.getUnreadNotificationCount();
  //     const { data, success } = res;
  //     if (success) {
  //       setUnreadNotificationCount(data?.notification);
  //     }
  //   } catch (error) {
  //     logger(error);
  //   }
  // };
  // const updateUnreadNotificationStatus = async () => {
  //   try {
  //     const res = await CommonService.updateUnreadNotificationStatus();
  //     const { data, success } = res;
  //     if (success) {
  //       setNotificationList(data?.notification?.rows);
  //       // getAdminData();
  //       getUnreadNotificationCount();
  //     }
  //   } catch (error) {
  //     logger(error);
  //   }
  // };

  useEffect(() => {
    getAdminData();
    // getUnreadNotificationCount();
  }, [menuToggle]);

  return (
    <div className="nk-header nk-header-fixed is-light">
      <div className="container-fluid">
        <div className="nk-header-wrap">
          <div className="nk-menu-trigger d-xl-none ms-n1">
            <Link
              onClick={() => menuToggle()}
              to="#"
              className="nk-nav-toggle nk-quick-nav-icon ps-0"
            >
              <em className="icon ni ni-menu" />
            </Link>
          </div>
          <div className="nk-header-brand d-xl-none">
            <Link to={adminRouteMap.DASHBOARD.path} className="logo-link">
              <div className="fs-5 fw-bold">{window.location.href.includes("instructor") ? "Instructor" : "Admin"}</div>

              {/* <ImageElement
                className="logo-img"
                previewSource="/assets/images/admin/logo-dark.svg"
                alt="logo"
              /> */}
            </Link>
          </div>
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              {/* Notifications Dropdown */}
              {/* <Dropdown
                as="li"
                className="notification-dropdown"
                onToggle={(e) => {
                  if (e) {
                    getNotificationData();
                  }
                }}
              >
                <Dropdown.Toggle
                  as="a"
                  className="nk-quick-nav-icon btn-icon btn-icon-break p-0"
                >
                  {unreadNotificationCount > 0 && (
                    <div className="badge badge-circle align-items-center bg-primary">
                      {unreadNotificationCount || 0}
                    </div>
                  )}
                  <em className="ni ni-bell" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="dropdown-menu-xl">
                  <div className="dropdown-head">
                    <span className="sub-title nk-dropdown-title">
                      Notifications
                    </span>
                    {unreadNotificationCount > 0 && (
                      <Link
                        className="text-info"
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          // updateUnreadNotificationStatus();
                        }}
                      >
                        Mark All Read
                      </Link>
                    )}
                  </div>
                  <div className="dropdown-body">
                    {!loading ? (
                      <div className="nk-notification">
                        {notificationList?.length > 0 ? (
                          <>
                            {notificationList &&
                              notificationList?.map((item) => (
                                <div className="nk-notification-item dropdown-inner">
                                  <div className="nk-notification-icon">
                                    <em className="icon icon-circle bg-warning-dim ni ni-curve-down-right" />
                                  </div>
                                  <div className="nk-notification-content">
                                    <div className="nk-notification-text">
                                      {item?.message}
                                    </div>
                                    <div className="nk-notification-time">
                                      {" "}
                                      {totalTimeDifference(
                                        item?.createdAt,
                                        new Date()
                                      )}{" "}
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </>
                        ) : (
                          <NoDataFound />
                        )}
                      </div>
                    ) : (
                      <div className="text-center">
                        <GlobalLoader />
                      </div>
                    )}
                  </div>
                  <div className="dropdown-foot center">
                    {notificationList && notificationList?.length > 0 && <Link
                      className="text-info"
                      to={adminRouteMap.ADMIN_NOTIFICATIONS.path}
                      onClick={() => {
                        document.body.click();
                      }}
                    >
                      View All
                    </Link>}
                  </div>
                </Dropdown.Menu>
              </Dropdown> */}
              {/* User Dropdown */}
              <Dropdown as="li" className="user-dropdown">
                <Dropdown.Toggle as="a" className="me-n1" id="dropdown-basic">
                  <div className="user-toggle">
                    <div className="user-avatar sm">
                      <ImageElement
                        previewSource={
                          adminData?.profileUrl ||
                          "/assets/images/admin/avatar/userImage.png"
                        }
                        className="img-fluid"
                        alt="profile"
                        origin="anonymous"
                      />
                    </div>
                    <div className="user-info d-none d-xl-block">
                      {/* <div className="user-status user-status-unverified">Unverified</div> */}
                      <div className="user-name dropdown-indicator">
                        {nameFormatter(adminData?.name, "")}
                      </div>
                    </div>
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end" className="dropdown-menu-md">
                  <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
                    <div className="user-card">
                      <div className="user-avatar">
                        {/* <span>AB</span> */}
                        <ImageElement
                          previewSource={
                            adminData.profileUrl ||
                            "/assets/images/admin/avatar/userImage.png"
                          }
                          className="img-fluid"
                          alt="profile"
                          origin="anonymous"
                        />
                      </div>
                      <div className="user-info">
                        <span className="lead-text">
                          {nameFormatter(adminData?.name, "")}
                        </span>
                        <span className="sub-text">
                          {textFormatter(adminData?.email)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <Link
                          to={adminRouteMap.ADMIN_PROFILE.path}
                          onClick={() => {
                            document.body.click();
                          }}
                        >
                          <em className="icon ni ni-user-alt" />
                          <span>{t("text.common.viewProfile")}</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={adminRouteMap.ADMIN_CHANGE_PASSWORD.path}
                          onClick={() => {
                            document.body.click();
                          }}
                        >
                          <em className="icon ni ni-lock-alt-fill" />
                          <span>{t("text.adminAuth.changePassword")}</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="dropdown-inner">
                    <ul className="link-list">
                      <li>
                        <Link
                          to="/"
                          onClick={(e) => {
                            e.preventDefault();
                            showSweetAlert();
                          }}
                        >
                          <em className="icon ni ni-signout" />
                          <span>{t("text.common.signOut")}</span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </Dropdown.Menu>
                <SweetAlert
                  reverseButtons
                  title="Logout"
                  text="Are you sure want to logout?"
                  show={isAlertVisible}
                  icon="warning"
                  showCancelButton
                  cancelButtonText="No"
                  confirmButtonText="Yes"
                  setIsAlertVisible={setIsAlertVisible}
                  showLoaderOnConfirm
                  loading={loading}
                  onConfirmAlert={onConfirmAlert}
                />
              </Dropdown>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminHeader;
